import { render, staticRenderFns } from "./InternalNotes.vue?vue&type=template&id=a90a151c&"
import script from "./InternalNotes.vue?vue&type=script&lang=js&"
export * from "./InternalNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports